import { useAssetDetailsContext } from "@/pages/asset-details/context/assetDetailsContext";
import { Grid } from "@material-ui/core";
import type { EditableCallbackParams } from "ag-grid-community";
type Props = EditableCallbackParams;

export const PartDescriptionColumn = ({ data }: Props) => {
	const {
		state: { dataPartSelected },
	} = useAssetDetailsContext();

	if (data?.id === -1) {
		return (
			<Grid
				container
				spacing={1}
				style={{ alignItems: "center", justifyContent: "center" }}
			>
				<Grid item style={{ alignItems: "center", justifyContent: "center" }}>
					{dataPartSelected?.Description}
				</Grid>
			</Grid>
		);
	} else if (data?.id !== -1) {
		return <>{data?.Description}</>;
	} else return <></>;
};
